import { FormLabel, Textinput } from "shared";
import {
    ITemplateComponent,
    ITemplatePdfPasswordComponent
} from "entities/template";
import React from "react";
import { useComponentsTranslations } from "../../../../lib/i18n";
import { VisibilityField } from "../../form_fields/visibility_field/visibility_field";
import { LabelField } from "../../form_fields/label_field/label_field";
import { TooltipField } from "../../form_fields/tooltip_field/tooltip_field";
import styles from "./component_form_pdf_password.module.scss";

interface IComponentFormInputProps {
    component: ITemplatePdfPasswordComponent;
    enLanguageEnabled: boolean;
    componentList: ITemplateComponent[];
    onChange: (component: ITemplateComponent) => void;
}

export const ComponentFormPdfPassword: React.FC<IComponentFormInputProps> = React.memo(({
                                                                                            component,
                                                                                            enLanguageEnabled,
                                                                                            componentList,
                                                                                            onChange
                                                                                        }) => {
    const t = useComponentsTranslations();

    const onFieldChange = (value: Partial<ITemplatePdfPasswordComponent>) => {
        onChange({
            ...component,
            ...value
        })
    }

    return <div className={styles.container}>
        <LabelField component={component}
                    enLanguageEnabled={enLanguageEnabled}
                    title={t("formLabel")}
                    name="label-dynamic-input"
                    onChange={onFieldChange}/>
        <FormLabel title={t("formTag")} required={true}>
            <Textinput size="m"
                       value={component.name}
                       disabled={true}
                       view="outline"/>
        </FormLabel>
        <VisibilityField
            component={component}
            componentList={componentList}
            onChange={onFieldChange}/>
        <TooltipField
            component={component}
            enLanguageEnabled={enLanguageEnabled}
            onChange={onFieldChange}
        />
    </div>;
});
